<template>

  <StepModel
        :ui="uiBasePersonal"
        :name="STEP_NAMES.personalInfo"
        ui-title="Profile Information"
        ui-subtitle="We need to ask you a few questions to create your profile
        and check if you are eligible for this product"
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetFullName :fieldset-name="FIELDSET_NAMES.fullNameReview" />
        <FieldsetEmail />
        <FieldsetMobilePhone  title="Your mobile number is" />
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.maritalStatus" ui-title="You are">
          <UiWrapper :name="FIELD_NAMES.maritalStatus">
            <Choice :options="MARITAL_STATUS" />
          </UiWrapper>
        </FieldsetModel>

        <!-- <FieldsetBornDate title="Your date of birth" label="Your date of birth" /> -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.living"
          ui-title="You have lived in the UAE for"
        >
          <UiWrapper :name="FIELD_NAMES.livingTime">
            <Dropdown
              placeholder="Select a time range"
              :options="[
                { value: '0-5 Months', label:'0-5 Months' },
                { value: '6-11 Months', label:'6-11 Months' },
                { value: '12-17 Months', label:'12-17 Months' },
                { value: '18-23 Months', label:'18-23 Months' },
                { value: '24-35 Months', label:'24-35 Months' },
                { value: '36-47 Months', label:'36-47 Months' },
                { value: '48-59 Months', label:'48-59 Months' },
                { value: '60-71 Months', label:'60-71 Months' },
                { value: '72+ Months', label:'72+ Months' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.residenceType"
          ui-title="You live in a"
        >
          <UiWrapper :name="FIELD_NAMES.residenceType">
            <Dropdown placeholder="Select your type of residence" :options="residenceTypes" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.areaOfWork"
          ui-title="Your office is in"
        >
          <UiWrapper :name="FIELD_NAMES.areaOfWork">
            <Dropdown placeholder="Select Emirate" :options="EMIRATE_LIST_CARD" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.fixedIncomeFieldset"
          ui-title="What is your fixed monthly income?"
        >
          <FieldIncome :name="FIELD_NAMES.fixedIncome" label="Enter your monthly income in AED" />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.variableIncomeFieldset"
          ui-title="What is your variable monthly income?"
        >
          <FieldIncome
            :name="FIELD_NAMES.variableIncome"
            label="Enter your variable income in AED"
          />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.mediumOfReceiveFieldSet"
          ui-title="How do you receive your monthly income?"
        >
          <UiWrapper :name="FIELD_NAMES.mediumOfReceive">
            <Dropdown
              placeholder="Select the mode"
              :options="[
                { value:'Bank account', label:'Bank account' },
                { value:'Exchange house', label:'Exchange house' },
                { value:'Cash', label:'Cash' },
                { value:'Cheque', label:'Cheque' },
                
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <!-- End code commented by Attra for the enhancement -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.instalmentsAmount"
          :presence="productIs(BRAND.loan)"
          ui-title="In how many years would you like to repay this loan?"
        >
          <UiWrapper :name="FIELD_NAMES.instalmentsAmount">
            <Dropdown
              placeholder="Select loan tenor"
              :options="[
                { value: '1', label:'1 year' },
                { value: '2', label:'2 years' },
                { value: '3', label:'3 years' },
                { value: '4', label:'4 years' },

              ]"
            />
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.haveLoansOrCreditCards"
          ui-title="Do you currently have any loans or credit cards?"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.haveLoan"
            :default-value="false"
            ui-title="What is the total amount you pay every month for all your loan instalments?"
          >
            <IncomeSwitcher switch-label="Loan" input-label="Enter your total monthly instalments" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.haveCreditCard"
            :default-value="false"
            ui-title="What is the total credit limit of all your credit cards?"
          >
            <IncomeSwitcher
              switch-label="Credit Card"
              input-label="Enter total limit for all credit cards"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.promoCodeDetails"
          ui-title="Do you have promo code?"
        >
          <UiWrapper :name="FIELD_NAMES.promoCode">
            <Choice
              :options="[
                {
                  value: 'Y',
                  label: 'Yes',
                },
                {
                  value: 'N',
                  label: 'No',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.promoCodeFields"
          :presence="isPromoCode"
          ui-columns="2"
        >
          <UiWrapper :name="FIELD_NAMES.promoCodeInput" label="Promo code">
            <InputText />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.promoCodeButton" optional>
            <Button type="button" color="white" :click="applyPromo" id="promoButton">
              <a href="#">Apply</a>
            </Button>
          </UiWrapper>
        </FieldsetModel>

        <FieldsetModel :ui="uiBaseFieldset" :ui-subtitle="``" name="PromoCodeMessage">
          <p hidden class="saving" id="spinner">
            <span class="dot"></span>
            <span class="dotText">Give us few seconds...</span>
          </p>
          <p id="promoMessage"></p>
        </FieldsetModel>
      </StepModel>
    
</template>
<script>

import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import IncomeSwitcher from "@/forms/components/ui-dunia/income-switcher";
import FieldIncome from "@/forms/components/shared/fields/income";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
import formService from "@/forms/api/services/form";
import flowManager from "@/lib/services/flow-manager";
// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";
import StepOtp from "@/forms/components/cards/stp-card/steps/otp";
import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetBornDate from "@/forms/components/shared/fieldsets/born-date";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetIBAN from "@/forms/components/shared/fieldsets/iban-number";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import StepOCREmirates from "@/forms/components/cards/stp-card/steps/ocr-emirates";
import StepIdentityReview from "@/forms/components/cards/stp-card/steps/identity-review";
import StepStatementUpload from "@/forms/components/cards/stp-card/steps/upload-statements";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import {
  SET_BANK_NAME,
  SET_FIRST_NAME,
  SET_SECOND_NAME,
  SET_BASIC_ELIGIBILITY,
  SET_PRODUCT_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE
} from "@/lib/constants/mutations";

import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";
export default {
    name: "StepPersonalInfo",

  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    UploadWrapper,
    IncomeSwitcher,
   
    
    FieldsetEmail,
    FieldsetBornDate,
    FieldsetMobilePhone,
    FieldsetFullName,
   
    FieldIncome,
    InputPassword,
    CheckWrapper,
    Expandable,
  
    Button,
    
  },

    data: () => ({
   
    applied: false,
    promoCodeDomMessage: "",
    profileTitle: "Profile Information",
    employmentInfo: "Employment Information",
    isVisible: true,
    search: ""
  }),
  mounted(){
let domElement = this.$el;

  },
      updated: function() {
   
    var promoButton = document.getElementById("promoButton");
    var promoChoice = document.getElementsByName("promoCode")[0];
    var buttonProfile = document.getElementById("profileSubmit");
    var promoCodeMessage = document.getElementById("promoMessage");
    var phoneNumber = document.getElementsByName("phoneNumber")[0];
    const { values } = store.state.formData;

    var phoneNumber = document.getElementsByName("phoneNumber")[0];
    if (phoneNumber) {
     // console.log('onffg');
      phoneNumber.addEventListener(
        "change",
        async function() {
          await formService.sendFormWithoutBlock();
        },
        false
      );
    }
    if (promoButton) {
      promoButton.style.border = "none";
    }
    if (promoChoice) {
      if (this.fieldValues(FIELD_NAMES.promoCode) === "Y") {
        this.applied = true;
        buttonProfile.disabled = true;
      } else {
        buttonProfile.disabled = false;
      }
    }

    // let bankName = this.$store.state.institutions.find(obj => {
    //   return obj.id === this.fieldValues(FIELD_NAMES.bankAccount);
    // });
    // if (typeof bankName !== "undefined") {
    //   store.commit(SET_BANK_NAME, { bankName: bankName.name });
    //   //localStorage.setItem('bankName', bankName.name);
    // }

    store.commit(SET_FIRST_NAME, {
      firstName: this.fieldValues(FIELD_NAMES.firstName)
    });
    store.commit(SET_SECOND_NAME, {
      lastName: this.fieldValues(FIELD_NAMES.lastName)
    });
    store.commit(SET_BASIC_ELIGIBILITY, {
      basicEligibility5000: this.fieldValues(FIELD_NAMES.fixedIncome)
    });
    store.commit(SET_INELIGIBLE_EMIRATES, {
      ineligibleEmirates: this.fieldValues(FIELD_NAMES.areaOfWork)
    });
    store.commit(SET_EMPLOYMENT_TYPE, {
      employmentType: this.fieldValues(FIELD_NAMES.employmentType)
    });
    store.commit(SET_INELIGIBLE_MEDIUM_OF_RECEIVE, {
      ineligibleMediumOfReceive: this.fieldValues(FIELD_NAMES.mediumOfReceive)
    });

  },

  computed: {
    isPromoCode() {
      return this.fieldValues(FIELD_NAMES.promoCode) === "Y";
    },
    getCountSalariesUploaded() {
      return this.uploadedFiles.filter(uploaded => uploaded).length;
    },
    variableIncomePresence() {
      const value = getLastEditValue(FIELD_NAMES.fixedIncome);
      const parsedIncome = parseFloat(value);
      return parsedIncome < MIN_FIXED_INCOME;
    },
    isSalaried() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Salaried";
    },
    isSelfEmployed() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Self-employed";
    },
    isSingleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Consolidated Statement"
      );
    },
    isMultipleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Monthly Statements"
      );
    },
    promoCodeResponseText() {
      return typeof this.$store.state.promoCodeResponse !== "undefined"
        ? this.$store.state.promoCodeResponse
        : "";
    },
    isQueryStringURL(value) {
      var queryStringObj = JSON.stringify(this.$store.state.querystrings);
      if (value.length > 0) {
        if (queryStringObj.includes(value)) {
          return false;
        }
      }
      if (value.length <= 0) {
        if (queryStringObj.includes("notVerified")) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    }
  },
   methods: {
    async applyPromo(event) {
      this.applied = true;
      var promoMessage = document.getElementById("promoMessage");
      var promoCodeInput = document.getElementsByName("promoCodeInput")[0];
      promoMessage.innerHTML = "";
      event.preventDefault();
      var button = document.getElementById("profileSubmit");
      const spinner = document.getElementById("spinner");

      spinner.removeAttribute("hidden");
      var currentStep = this.STEP_NAMES.personalInfo;
      if (this.fieldValues(FIELD_NAMES.promoCodeInput)) {
        await promoCodeService.validatePromoCode(currentStep, this);
        var promocodeMessage = this.$store.state.promoCodeResponse;
        var promoCodeStatus = this.$store.state.promoCodeStatus;

        if (promoCodeStatus === "INVALID" || "EXPIRED") {
          promoMessage.innerHTML = promocodeMessage;
          promoMessage.style.color = "#ff0000";

          promoCodeInput.value = "";
        }
        if (promoCodeStatus === "SUCCESS") {
          promoMessage.style.color = "#6e3dea";
          promoMessage.innerHTML = promocodeMessage;
          promoCodeInput.value = this.fieldValues(FIELD_NAMES.promoCodeInput);
        }

        if (!promoCodeStatus) {
          promoMessage.style.color = "#ff0000";
          promoCodeInput.value = this.fieldValues(FIELD_NAMES.promoCodeInput);
          promoMessage.innerHTML =
            "Oops! an error occured while processing your request.";
        }
      } else {
        document.getElementById("promoMessage").style.color = "#ff0000";
        promoMessage.innerHTML = "promo code must not be empty.";
      }
      button.disabled = false;
      spinner.setAttribute("hidden", "");
    },

   // ...conditions,
    //salaryVerification: uploadService.salaryVerification,
    // increaseSalariesUploaded(index) {
    //   Vue.set(this.uploadedFiles, index, true);
    // },
    isBankFieldsVisible(value) {
      if (value === "Bank account") {
        this.isVisible = true;
      } else if (value === "Exchange house") {
        this.isVisible = false;
      }
    },
    persistStep2() {
      return formService.sendFormWithoutBlock();
    },
    signalChange: function(evt) {
      this.$emit("change", evt);

    },
    
  },
  watch: {
    open () {
     
   var el=   document.getElementsByName("phoneNumber")[0];
   el.innerHTML='2342322';
   //.style.display = (this.open) ? "inline": "none";
    }
 }
   
}

</script>
<style  scoped>
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
/* #promoButton:hover {
  text-decoration: underline;
} */

#promoButton > a {
  position: relative;
  color: #000000;
  text-decoration: none;
}

#promoButton > a:hover {
  color: #000000;
}
#promoButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #000000;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

#promoButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
</style>
